import React from "react"
import { Container, Row, Col } from "reactstrap"
import * as url from "../../helpers/url_helper"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
          <Col md={6}>{new Date().getFullYear()} © E-Recruitment</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                {url.COMPANY}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
